import { NavLink } from 'react-router-dom';
import { t } from '@/i18n';
import styles from './Sidebar.module.css';

const menuItems = [
  { to: '/', label: t.nav.home, icon: String.fromCodePoint(0x1f3e0), end: true as const },
  { to: '/spread', label: t.nav.newSpread, icon: String.fromCodePoint(0x1f0cf) },
  { to: '/result', label: t.nav.result, icon: String.fromCodePoint(0x1f4cb) },
] as const;

const accountItems = [{ to: '/profile', label: t.nav.profile, icon: String.fromCodePoint(0x1f464) }] as const;

export function Sidebar() {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.sectionLabel}>{t.nav.menu}</div>
      <nav className={styles.nav} aria-label={t.nav.ariaMenu}>
        {menuItems.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={'end' in it ? it.end : false}
            className={({ isActive }) =>
              [styles.link, isActive ? styles.linkActive : ''].filter(Boolean).join(' ')
            }
          >
            <span className={styles.ico} aria-hidden>
              {it.icon}
            </span>
            {it.label}
          </NavLink>
        ))}
      </nav>

      <hr className={styles.divider} />

      <div className={styles.sectionLabel}>{t.nav.account}</div>
      <nav className={styles.nav} aria-label={t.nav.ariaAccount}>
        {accountItems.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            className={({ isActive }) =>
              [styles.link, isActive ? styles.linkActive : ''].filter(Boolean).join(' ')
            }
          >
            <span className={styles.ico} aria-hidden>
              {it.icon}
            </span>
            {it.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
